
import { Card, CardHeader, CardContent, CardFooter, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { useState } from "react";
import { useToast } from "@/hooks/use-toast";
import { Calendar, Clock, BarChart, LinkIcon } from "lucide-react";

interface OfferActionsProps {
  price: number;
  linkType: string;
  turnaroundDays: number;
  onPurchase: () => void;
}

const OfferActions = ({
  price,
  linkType,
  turnaroundDays,
  onPurchase,
}: OfferActionsProps) => {
  const [messageText, setMessageText] = useState("");
  const { toast } = useToast();

  const handleSendMessage = () => {
    if (!messageText.trim()) {
      toast({
        title: "Error",
        description: "Please enter a message",
        variant: "destructive",
      });
      return;
    }
    
    toast({
      title: "Message Sent",
      description: "Your message has been sent to the seller.",
    });
    
    setMessageText("");
  };

  return (
    <Card className="bg-white">
      <CardHeader>
        <CardTitle className="text-2xl font-bold">
          ${(price ? price / 100 : 0).toFixed(2)}
        </CardTitle>
        <div className="text-gray-500">
          One-time payment for this backlink
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center gap-2">
          <LinkIcon className="h-5 w-5 text-gray-500" />
          <span>{linkType || "Standard Link"}</span>
        </div>
        <div className="flex items-center gap-2">
          <Clock className="h-5 w-5 text-gray-500" />
          <span>{turnaroundDays || "N/A"} days turnaround</span>
        </div>
        
        <Button onClick={onPurchase} className="w-full" size="lg">
          Purchase Now
        </Button>
        
        <Dialog>
          <DialogTrigger asChild>
            <Button variant="outline" className="w-full">
              Contact Seller
            </Button>
          </DialogTrigger>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>Message to Seller</DialogTitle>
            </DialogHeader>
            <div className="py-4">
              <Textarea 
                placeholder="Type your message here..."
                className="min-h-[150px]"
                value={messageText}
                onChange={(e) => setMessageText(e.target.value)}
              />
            </div>
            <Button onClick={handleSendMessage}>Send Message</Button>
          </DialogContent>
        </Dialog>
      </CardContent>
      <CardFooter className="flex flex-col items-start">
        <div className="flex items-center gap-2 text-sm text-gray-500 mb-2">
          <Calendar className="h-4 w-4" />
          30-day money back guarantee
        </div>
        <div className="flex items-center gap-2 text-sm text-gray-500">
          <BarChart className="h-4 w-4" />
          DR/DA verified weekly
        </div>
      </CardFooter>
    </Card>
  );
};

export default OfferActions;
